const Builder = require('./BuilderBase');
const Layout = require('./Layout');

module.exports = class GreedySectionLayout extends Builder {
    constructor(title, properties) {
        super('layout_GreedySectionLayout', title, properties);
    }

    first(title, properties) {
        let layout = new Layout(title, properties);
        this.addChildBlock(layout, 'first');
        return layout;
    }

    middle(title, properties) {
        let layout = new Layout(title, properties);
        this.addChildBlock(layout, 'middle');
        return layout;
    }

    last(title, properties) {
        let layout = new Layout(title, properties);
        this.addChildBlock(layout, 'last');
        return layout;
    }
};
